import React, { useEffect, useState } from 'react';
import { Dropdown, UploadWhiteIcon } from '../../svg';
import { useFormik } from 'formik';
import * as yup from "yup";
import settingStyle from './settings.module.css'
import { CircularProgress, MenuItem, Select } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getProfile, setLogin } from '../redux/userSlice';
import { updatePassword, updateProfile } from '../redux/settingSlice';
import api from '../helper/Api';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ChangePassword from '../../component/ChangePassword';
import Toastify from '../helper/Toastify';

import AffiliateChangePassword from '../../component/AffiliateChangePassword';
import DeleteAccountAffiliate from '../../component/DeleteAccountAffiliate';
import OtpModalAffiliate from '../../component/otpModalAffiliate';


const AffiliateSettings = ({ getUserProfile }) => {
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false)
    const [Data, setData] = useState([])
    const [deleteModal, setDeleteModal] = useState(false);
    const [datas, setdatas] = useState([])

    const openDeleteModal = (data) => {
        setdatas(data)
        setDeleteModal(true)
    }
    const closeDeleteModal = () => {
        setDeleteModal(false)
    }
    const schema = yup.object().shape({
        name: yup.string().required("Name is required"),
        email: yup.string().required("Email is required"),
        phone: yup.number().min(1, "Value must be number").required("Phone is required"),

    })

    const {
        errors,
        values,
        handleChange,
        touched,
        setValues,
        handleBlur,
        handleSubmit,
        setFieldValue,
    } = useFormik({
        initialValues: {
            name: "",
            profileImg: [],
            email: "",
            phone: 0,
            country: "",
            bio: "",

        },
        validationSchema: schema,
        onSubmit: (values) => {
            setData(values)
            updateSubject(values)
        }
    })

    const updateSubject = async () => {
        try {
            setLoading(true)
            const { data, status } = await api.AffiliateupdateProfile(values)

            if (data.data.message === 'Update Successfull') {
                dispatch(setLogin(data?.data?.data))
                Toastify.success("Profile Updated Successfully")

            } else {
                //modal open
                setShowModal(true)
            }

        } catch (error) {
            console.log("error uploading details", error)
            Toastify.error(error.response.data.message || `something went wrong`)
        } finally {
            setLoading(false)

        }
    }



    useEffect(() => {
        if (getUserProfile) {
            setValues({
                name: getUserProfile?.name || '',
                profileImg: getUserProfile?.profileImg || [],
                email: getUserProfile?.email || '',
                phone: getUserProfile?.phone || '',
                country: getUserProfile?.country || '',
                bio: getUserProfile?.bio || '',
            })
        }
    }, [getUserProfile, setValues])

    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            const body = new FormData();
            body.set("image", file);
            const { data, status } = await api.fileUpload(body);
            console.log(data, "data");

            if (status === 200) {
                setFieldValue("profileImg", data.data); // replace the current image with the new one
            }
        }
    };


    const maskEmail = (email) => {
        if (!email || typeof email !== 'string') {
            return ""; // Return an empty string or a default masked email if the input is invalid
        }
        const [username, domain] = email?.split("@"); // Split into username and domain
        if (username.length <= 2) {
            // If the username is too short, keep only the first character and mask the rest
            return `${username[0]}***@${domain}`;
        }
        // Otherwise, keep the first two characters and mask the rest
        return `${username.substring(0, 2)}***@${domain}`;
    };

    return (
        <div style={{ padding: 20, marginTop: 20 }} >


            <h3 className={settingStyle.accountHeading}>Account Settings</h3>

            <div className={settingStyle.mainContainer}>
                <div className={settingStyle.imageCard}>
                    <label htmlFor="upload-photo" className={settingStyle.uploadOverlay}>
                        {values?.profileImg?.length > 0 ? (
                            <img src={values?.profileImg} alt="Profile" className={settingStyle.uploadedImage} />
                        ) : (
                            <div className={settingStyle.uploadPlaceholder}>Upload Photo</div>
                        )}
                        <div className={settingStyle.overlayText}><UploadWhiteIcon />Upload Photo</div>
                    </label>
                    <input
                        type="file"
                        id="upload-photo"
                        accept="image/*"
                        onChange={handleImageChange}
                        style={{ display: 'none' }}
                    />

                    <p className={settingStyle.imageGuidelines}>
                        Image size 280 x 280, 1MB and image ratio needs to be 1:1
                    </p>
                </div>
                <div className={settingStyle.accountCard}>
                    <h3 className={settingStyle.accountH3}>Account</h3>
                    <div className={settingStyle.cardContainer}>
                        <div className={settingStyle.widthStyle}>
                            <label className={settingStyle.labelStyle}>Student name</label>
                            <div className={settingStyle.inputBox} >
                                <input type='text' onBlur={handleBlur} value={values.name} placeholder='Your Name...' name="name" onChange={handleChange} />
                            </div>
                            {
                                errors.name && touched.name && <p style={{ color: "red", fontSize: "12px" }}>{errors.name}</p>
                            }
                        </div>
                        <div className={settingStyle.widthStyle}>
                            <label className={settingStyle.labelStyle}>Email Id</label>
                            <div className={settingStyle.inputBox}>
                                <input type='text' onBlur={handleBlur} value={values.email} placeholder='Your Email Id...' name="email" onChange={handleChange} />
                            </div>
                            {
                                errors.email && touched.email && <p style={{ color: "red", fontSize: "12px" }}>{errors.email}</p>
                            }
                        </div>
                    </div>
                    <div className={settingStyle.cardContainer} style={{ paddingTop: 20 }}>
                        <div className={settingStyle.widthStyle}>
                            <label className={settingStyle.labelStyle}>Contact number</label>
                            <div className={settingStyle.inputBox}>
                                <input type='number' onBlur={handleBlur} value={values.phone || ''} placeholder='Your Contact Number...' name="phone" onChange={handleChange} />
                            </div>
                            {
                                errors.phone && touched.phone && <p style={{ color: "red", fontSize: "12px" }}>{errors.phone}</p>
                            }
                        </div>
                        <div className={settingStyle.widthStyle}>
                            <label className={settingStyle.labelStyle}>Bio</label>
                            <div>
                                <div className={settingStyle.inputBox}>
                                    <input type='text' onBlur={handleBlur} value={values.bio || ''} placeholder='Enter title/proffession' name="bio" onChange={handleChange} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={settingStyle.changesPasswordButton} onClick={handleSubmit} style={{ width: "100px" }}>
                        <p>{loading ? <CircularProgress size={20} /> : `Save`} </p>
                    </div>
                    <div className={settingStyle.bottomLine} />
                    <AffiliateChangePassword />
                    <div className={settingStyle.bottomLine} />
                    <h6 className={settingStyle.headingh6}>
                        Delete Account
                    </h6>
                    <div className={settingStyle.description}>
                        If you delete your account, your personal information will be wiped from Kingster's servers,
                        all of your course activity will be anonymized and any certificates earned will be deleted. This
                        action cannot be undone! <span>Cancel any active subscriptions before you delete your account.</span>
                    </div>
                    <div className={settingStyle.changesPasswordButton} onClick={() => openDeleteModal()}>
                        <p>Delete Account</p>
                    </div>
                </div>
            </div>

            <OtpModalAffiliate
                open={showModal}
                desc={`We have sent you an OTP to your  ${maskEmail(getUserProfile?.email)}, please check and verify.`}
                data={Data}
                closeModal={() => setShowModal(false)}

            />
            <DeleteAccountAffiliate
                open={deleteModal}
                closeModal={closeDeleteModal}
            // id={datas}
            />
        </div >
    )
}

export default AffiliateSettings;